import * as React from 'react';

import {Body} from 'shells/typography/body';
import {Header} from 'shells/typography/header';
import {Subheader} from 'shells/typography/subheader';

import {getAuthUrl} from '../../utils';

import type {LoginVariant} from '../login-page';
import {MULTI_ACCOUNT_LOGIN_MODES, type MultiAccountLoginMode} from '../types';

import {LoginFlowButton} from './login-flow-button';

import styles from '../login-form.module.css';

type Props = {
    emailValue: string | null | undefined;
    ssoRedirectUrl: string | null | undefined;
    setVariant: (variant: LoginVariant) => void;
    loginMode: MultiAccountLoginMode | null;
};

export function ChooseMethodPage(props: Props) {
    return (
        <>
            <Header>
                {props.loginMode === MULTI_ACCOUNT_LOGIN_MODES.SWITCHING
                    ? 'Sign back in'
                    : 'Sign in'}
            </Header>
            <Subheader>
                You are{' '}
                {props.loginMode === MULTI_ACCOUNT_LOGIN_MODES.SWITCHING
                    ? 'signing back in'
                    : 'signing in'}{' '}
                as{' '}
                <Body size='large' wrapAnywhere={true}>
                    {props.emailValue}
                </Body>
            </Subheader>
            <div className='flex flex-dir-col gap-0'>
                <LoginFlowButton
                    bttnVariant='primary'
                    onClick={() => {
                        // @ts-expect-error
                        window.location.replace(getAuthUrl(props.ssoRedirectUrl));
                    }}
                >
                    Continue with SSO
                </LoginFlowButton>
                <div className={styles['link-button']}>
                    <LoginFlowButton
                        bttnVariant='text-primary'
                        onClick={() => {
                            props.setVariant('password');
                        }}
                    >
                        Continue with password
                    </LoginFlowButton>
                </div>
            </div>
        </>
    );
}
